import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

const HOUR_BANDS = [
  { color: '#009688', label: '0 – 3 hrs' },
  { color: '#0089ff', label: '3 – 5 hrs' },
  { color: '#ff0000', label: '5 – 8 hrs' },
  { color: '#ff9800', label: '8+ hrs' },
];

export default function ColorLegend() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1, flexWrap: 'wrap' }}>
      <Typography variant="caption" sx={{ color: '#888', fontWeight: 600, letterSpacing: 0.5 }}>
        EST. HOURS:
      </Typography>

      {HOUR_BANDS.map(({ color, label }) => (
        <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }} />
          <Typography variant="caption" sx={{ color: '#555', fontWeight: 500 }}>
            {label}
          </Typography>
        </Box>
      ))}

      <Box sx={{ width: '1px', height: 14, backgroundColor: '#ddd', mx: 0.5 }} />

      <Tooltip
        title="For '1/2 Survey Crew', color is based on 50% of the total estimated hours since the effort is shared between two crew members."
        arrow
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            backgroundColor: 'rgba(61,173,181,0.08)',
            border: '1px dashed #3DADB5',
            borderRadius: '10px',
            px: 1,
            py: 0.25,
            cursor: 'default',
          }}
        >
          <Typography variant="caption" sx={{ color: '#3DADB5', fontWeight: 700, fontSize: '0.68rem' }}>
            ½ Survey Crew
          </Typography>
          <Typography variant="caption" sx={{ color: '#555', fontWeight: 500, fontSize: '0.68rem' }}>
            = 50% of hrs
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
}
